module.exports = __webpack_public_path__ + "img/1.fde00c42.jpg";